import { render, staticRenderFns } from "./LogPassportReport.vue?vue&type=template&id=7a672436&scoped=true"
import script from "./LogPassportReport.vue?vue&type=script&lang=js"
export * from "./LogPassportReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a672436",
  null
  
)

export default component.exports